import React, { useState } from 'react';
import { supabase } from '../../../services/supabaseClient';

const EditEducationModal = ({ submissionId, educationData, onClose, onSave }) => {
    const [formData, setFormData] = useState(educationData || {});
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        try {
            const { error } = await supabase
                .from('wizard_submissions')
                .update({ education_info: formData })
                .eq('id', submissionId);

            if (error) throw error;
            if (onSave) await onSave();
            onClose();
        } catch (err) {
            console.error('Error saving education:', err);
            alert('Failed to save education information');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex items-center justify-between sticky top-0">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">Edit Education</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-white"
                    >
                        ✕
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Highest Education</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.highestEducation || ''}
                                onChange={(e) => setFormData({ ...formData, highestEducation: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Field of Study</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.fieldOfStudy || ''}
                                onChange={(e) => setFormData({ ...formData, fieldOfStudy: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Institution</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.institution || ''}
                                onChange={(e) => setFormData({ ...formData, institution: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Graduation Year</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.graduationYear || ''}
                                onChange={(e) => setFormData({ ...formData, graduationYear: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">GPA</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.gpa || ''}
                                onChange={(e) => setFormData({ ...formData, gpa: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Country</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.country || ''}
                                onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="flex gap-3 justify-end mt-6 pt-4 border-t border-gray-700">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded text-sm font-bold bg-gray-700 text-white hover:bg-gray-600 border border-gray-600"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            disabled={saving}
                            className="px-4 py-2 rounded text-sm font-bold bg-blue-600 text-white hover:bg-blue-700 border border-blue-500 disabled:opacity-50"
                        >
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditEducationModal;
